(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coleccion-destacada-old-money"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.omcdColeccionListo) {
    return;
  }
  window.omcdColeccionListo = true;

  function manejarEnvioFormulario(formulario) {
    var boton = formulario.querySelector('[data-omcd-agregar]');
    if (!boton || boton.disabled || boton.getAttribute('data-cargando') === 'true') {
      return;
    }

    var campoVariante = formulario.querySelector('input[name="id"]');
    var variantId = campoVariante ? campoVariante.value : '';
    var errorEl = formulario.querySelector('[data-omcd-error]');

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    if (!variantId) {
      if (errorEl) {
        errorEl.textContent = 'Este producto no tiene una variante disponible para agregar.';
        errorEl.hidden = false;
      }
      return;
    }

    var textoSpan = boton.querySelector('.omcd-boton-texto');
    var textoOriginal = textoSpan ? textoSpan.textContent : '';
    var textoCargando = boton.getAttribute('data-texto-cargando') || 'Agregando...';
    boton.setAttribute('data-cargando', 'true');
    if (textoSpan) {
      textoSpan.textContent = textoCargando;
    }

    var cuerpo = { id: variantId, quantity: 1 };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (respuesta) {
        return respuesta.json().then(function (datos) {
          if (!respuesta.ok) {
            var mensaje = (datos && (datos.description || datos.message)) || 'No se pudo agregar el producto.';
            throw new Error(mensaje);
          }
          return datos;
        });
      })
      .then(function () {
        if (textoSpan) {
          textoSpan.textContent = textoOriginal;
        }
        boton.removeAttribute('data-cargando');
      })
      .catch(function (error) {
        if (textoSpan) {
          textoSpan.textContent = textoOriginal;
        }
        boton.removeAttribute('data-cargando');
        if (errorEl) {
          errorEl.textContent = error && error.message ? error.message : 'No se pudo agregar el producto.';
          errorEl.hidden = false;
        }
        if (window.console && window.console.error) {
          window.console.error('omcd: error al agregar al carrito', error);
        }
      });
  }

  document.addEventListener('submit', function (evento) {
    var formulario = evento.target.closest('[data-omcd-formulario]');
    if (!formulario) {
      return;
    }
    if (evento.defaultPrevented) {
      return;
    }
    evento.preventDefault();
    manejarEnvioFormulario(formulario);
  });

  function parsearHora(valor, minutosPorDefecto) {
    if (!valor) {
      return minutosPorDefecto;
    }
    var partes = valor.split(':');
    var horas = parseInt(partes[0], 10);
    var minutos = partes.length > 1 ? parseInt(partes[1], 10) : 0;
    if (isNaN(horas)) {
      return minutosPorDefecto;
    }
    if (isNaN(minutos)) {
      minutos = 0;
    }
    return (horas * 60) + minutos;
  }

  function calcularProximoDia(diaActual, minutosDelDia, reglas) {
    var corteHoy = reglas[diaActual];
    if (typeof corteHoy === 'number' && minutosDelDia < corteHoy) {
      return 0;
    }
    for (var i = 1; i <= 7; i++) {
      var d = (diaActual + i) % 7;
      if (typeof reglas[d] === 'number') {
        return i;
      }
    }
    return null;
  }

  function nombreParaOffset(offset, diaActual, textoHoy, textoManana, nombresDias) {
    if (offset === 0) {
      return textoHoy;
    }
    if (offset === 1) {
      return textoManana;
    }
    var d = (diaActual + offset) % 7;
    return 'el ' + nombresDias[d];
  }

  function actualizarEntregaAutomatica() {
    var contenedores = document.querySelectorAll('[data-omcd-corte-semana-mvd]');
    if (!contenedores.length) {
      return;
    }

    var nombresDias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var diasAbrev = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var partesFecha;

    try {
      partesFecha = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Montevideo',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (error) {
      return;
    }

    var datosFecha = {};
    partesFecha.forEach(function (parte) {
      datosFecha[parte.type] = parte.value;
    });

    var diaActual = diasAbrev.indexOf(datosFecha.weekday);
    var horaActual = parseInt(datosFecha.hour, 10);
    if (horaActual === 24) {
      horaActual = 0;
    }
    var minutoActual = parseInt(datosFecha.minute, 10);

    if (diaActual === -1 || isNaN(horaActual) || isNaN(minutoActual)) {
      return;
    }

    var minutosDelDia = (horaActual * 60) + minutoActual;

    contenedores.forEach(function (contenedor) {
      var corteSemanaMvd = parsearHora(contenedor.getAttribute('data-omcd-corte-semana-mvd'), 14 * 60);
      var corteSabadoMvd = parsearHora(contenedor.getAttribute('data-omcd-corte-sabado-mvd'), 10 * 60);
      var corteSemanaInt = parsearHora(contenedor.getAttribute('data-omcd-corte-semana-int'), (18 * 60) + 30);
      var plantillaMvd = contenedor.getAttribute('data-omcd-plantilla-mvd') || '';
      var plantillaInt = contenedor.getAttribute('data-omcd-plantilla-int') || '';
      var textoHoy = contenedor.getAttribute('data-omcd-texto-hoy') || 'hoy';
      var textoManana = contenedor.getAttribute('data-omcd-texto-manana') || 'mañana';

      var reglasMvd = { 0: null, 1: corteSemanaMvd, 2: corteSemanaMvd, 3: corteSemanaMvd, 4: corteSemanaMvd, 5: corteSemanaMvd, 6: corteSabadoMvd };
      var reglasInt = { 0: null, 1: corteSemanaInt, 2: corteSemanaInt, 3: corteSemanaInt, 4: corteSemanaInt, 5: corteSemanaInt, 6: null };

      var offsetMvd = calcularProximoDia(diaActual, minutosDelDia, reglasMvd);
      var offsetInt = calcularProximoDia(diaActual, minutosDelDia, reglasInt);

      if (offsetMvd !== null && plantillaMvd) {
        var textoFinalMvd = plantillaMvd.replace('[dia]', nombreParaOffset(offsetMvd, diaActual, textoHoy, textoManana, nombresDias));
        contenedor.querySelectorAll('[data-omcd-entrega-mvd]').forEach(function (el) {
          el.textContent = textoFinalMvd;
        });
      }

      if (offsetInt !== null && plantillaInt) {
        var textoFinalInt = plantillaInt.replace('[dia]', nombreParaOffset(offsetInt, diaActual, textoHoy, textoManana, nombresDias));
        contenedor.querySelectorAll('[data-omcd-entrega-int]').forEach(function (el) {
          el.textContent = textoFinalInt;
        });
      }
    });
  }

  actualizarEntregaAutomatica();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.omcatCatalogoListo) {
    return;
  }
  window.omcatCatalogoListo = true;

  function manejarEnvioFormulario(formulario) {
    var boton = formulario.querySelector('[data-omcat-agregar]');
    if (!boton || boton.disabled || boton.getAttribute('data-cargando') === 'true') {
      return;
    }

    var campoVariante = formulario.querySelector('input[name="id"]');
    var variantId = campoVariante ? campoVariante.value : '';
    var errorEl = formulario.querySelector('[data-omcat-error]');

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    if (!variantId) {
      if (errorEl) {
        errorEl.textContent = 'Este producto no tiene una variante disponible para agregar.';
        errorEl.hidden = false;
      }
      return;
    }

    var textoSpan = boton.querySelector('.omcat-boton-texto');
    var textoOriginal = textoSpan ? textoSpan.textContent : '';
    var textoCargando = boton.getAttribute('data-texto-cargando') || 'Agregando...';
    boton.setAttribute('data-cargando', 'true');
    if (textoSpan) {
      textoSpan.textContent = textoCargando;
    }

    var cuerpo = { id: variantId, quantity: 1 };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (respuesta) {
        return respuesta.json().then(function (datos) {
          if (!respuesta.ok) {
            var mensaje = (datos && (datos.description || datos.message)) || 'No se pudo agregar el producto.';
            throw new Error(mensaje);
          }
          return datos;
        });
      })
      .then(function () {
        if (textoSpan) {
          textoSpan.textContent = textoOriginal;
        }
        boton.removeAttribute('data-cargando');
      })
      .catch(function (error) {
        if (textoSpan) {
          textoSpan.textContent = textoOriginal;
        }
        boton.removeAttribute('data-cargando');
        if (errorEl) {
          errorEl.textContent = error && error.message ? error.message : 'No se pudo agregar el producto.';
          errorEl.hidden = false;
        }
        if (window.console && window.console.error) {
          window.console.error('omcat: error al agregar al carrito', error);
        }
      });
  }

  document.addEventListener('submit', function (evento) {
    var formulario = evento.target.closest('[data-omcat-formulario]');
    if (!formulario) {
      return;
    }
    if (evento.defaultPrevented) {
      return;
    }
    evento.preventDefault();
    manejarEnvioFormulario(formulario);
  });

  function parsearHora(valor, minutosPorDefecto) {
    if (!valor) {
      return minutosPorDefecto;
    }
    var partes = valor.split(':');
    var horas = parseInt(partes[0], 10);
    var minutos = partes.length > 1 ? parseInt(partes[1], 10) : 0;
    if (isNaN(horas)) {
      return minutosPorDefecto;
    }
    if (isNaN(minutos)) {
      minutos = 0;
    }
    return (horas * 60) + minutos;
  }

  function calcularProximoDia(diaActual, minutosDelDia, reglas) {
    var corteHoy = reglas[diaActual];
    if (typeof corteHoy === 'number' && minutosDelDia < corteHoy) {
      return 0;
    }
    for (var i = 1; i <= 7; i++) {
      var d = (diaActual + i) % 7;
      if (typeof reglas[d] === 'number') {
        return i;
      }
    }
    return null;
  }

  function nombreParaOffset(offset, diaActual, textoHoy, textoManana, nombresDias) {
    if (offset === 0) {
      return textoHoy;
    }
    if (offset === 1) {
      return textoManana;
    }
    var d = (diaActual + offset) % 7;
    return 'el ' + nombresDias[d];
  }

  function actualizarEntregaAutomatica() {
    var contenedores = document.querySelectorAll('[data-omcat-corte-semana-mvd]');
    if (!contenedores.length) {
      return;
    }

    var nombresDias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var diasAbrev = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var partesFecha;

    try {
      partesFecha = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Montevideo',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (error) {
      return;
    }

    var datosFecha = {};
    partesFecha.forEach(function (parte) {
      datosFecha[parte.type] = parte.value;
    });

    var diaActual = diasAbrev.indexOf(datosFecha.weekday);
    var horaActual = parseInt(datosFecha.hour, 10);
    if (horaActual === 24) {
      horaActual = 0;
    }
    var minutoActual = parseInt(datosFecha.minute, 10);

    if (diaActual === -1 || isNaN(horaActual) || isNaN(minutoActual)) {
      return;
    }

    var minutosDelDia = (horaActual * 60) + minutoActual;

    contenedores.forEach(function (contenedor) {
      var corteSemanaMvd = parsearHora(contenedor.getAttribute('data-omcat-corte-semana-mvd'), 14 * 60);
      var corteSabadoMvd = parsearHora(contenedor.getAttribute('data-omcat-corte-sabado-mvd'), 10 * 60);
      var corteSemanaInt = parsearHora(contenedor.getAttribute('data-omcat-corte-semana-int'), (18 * 60) + 30);
      var plantillaMvd = contenedor.getAttribute('data-omcat-plantilla-mvd') || '';
      var plantillaInt = contenedor.getAttribute('data-omcat-plantilla-int') || '';
      var textoHoy = contenedor.getAttribute('data-omcat-texto-hoy') || 'hoy';
      var textoManana = contenedor.getAttribute('data-omcat-texto-manana') || 'mañana';

      var reglasMvd = { 0: null, 1: corteSemanaMvd, 2: corteSemanaMvd, 3: corteSemanaMvd, 4: corteSemanaMvd, 5: corteSemanaMvd, 6: corteSabadoMvd };
      var reglasInt = { 0: null, 1: corteSemanaInt, 2: corteSemanaInt, 3: corteSemanaInt, 4: corteSemanaInt, 5: corteSemanaInt, 6: null };

      var offsetMvd = calcularProximoDia(diaActual, minutosDelDia, reglasMvd);
      var offsetInt = calcularProximoDia(diaActual, minutosDelDia, reglasInt);

      if (offsetMvd !== null && plantillaMvd) {
        var textoFinalMvd = plantillaMvd.replace('[dia]', nombreParaOffset(offsetMvd, diaActual, textoHoy, textoManana, nombresDias));
        contenedor.querySelectorAll('[data-omcat-entrega-mvd]').forEach(function (el) {
          el.textContent = textoFinalMvd;
        });
      }

      if (offsetInt !== null && plantillaInt) {
        var textoFinalInt = plantillaInt.replace('[dia]', nombreParaOffset(offsetInt, diaActual, textoHoy, textoManana, nombresDias));
        contenedor.querySelectorAll('[data-omcat-entrega-int]').forEach(function (el) {
          el.textContent = textoFinalInt;
        });
      }
    });
  }

  actualizarEntregaAutomatica();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    (function () {
      if (window.omprodEntregaListo) { return; }
      window.omprodEntregaListo = true;

      var nombresDias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

      function parsearHora(texto) {
        if (!texto) { return null; }
        var partes = texto.split(':');
        var horas = parseInt(partes[0], 10);
        var minutos = parseInt(partes[1], 10);
        if (isNaN(horas) || isNaN(minutos)) { return null; }
        return (horas * 60) + minutos;
      }

      function calcularProximoDia(diaActual, minutosDelDia, reglas) {
        var corteHoy = reglas[diaActual];
        if (corteHoy !== null && corteHoy !== undefined && minutosDelDia < corteHoy) {
          return 0;
        }
        for (var i = 1; i <= 7; i++) {
          var diaCandidato = (diaActual + i) % 7;
          var corteCandidato = reglas[diaCandidato];
          if (corteCandidato !== null && corteCandidato !== undefined) {
            return i;
          }
        }
        return null;
      }

      function nombreParaOffset(offset, diaActual, textoHoy, textoManana) {
        if (offset === 0) { return textoHoy; }
        if (offset === 1) { return textoManana; }
        var diaDestino = (diaActual + offset) % 7;
        return 'el ' + nombresDias[diaDestino];
      }

      function actualizarEntregaAutomatica() {
        var contenedores = document.querySelectorAll('[data-omprod-plantilla-mvd], [data-omprod-plantilla-int]');
        if (!contenedores.length) { return; }

        var partes = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Montevideo',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }).formatToParts(new Date());

        var diasSemana = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        var diaActual = 0;
        var horas = 0;
        var minutos = 0;

        partes.forEach(function (parte) {
          if (parte.type === 'weekday') { diaActual = diasSemana[parte.value]; }
          if (parte.type === 'hour') { horas = parseInt(parte.value, 10); }
          if (parte.type === 'minute') { minutos = parseInt(parte.value, 10); }
        });

        if (horas === 24) { horas = 0; }
        var minutosDelDia = (horas * 60) + minutos;

        contenedores.forEach(function (contenedor) {
          var textoHoy = contenedor.getAttribute('data-omprod-texto-hoy') || 'hoy';
          var textoManana = contenedor.getAttribute('data-omprod-texto-manana') || 'mañana';

          var corteSemanaMvd = parsearHora(contenedor.getAttribute('data-omprod-corte-semana-mvd'));
          var corteSabadoMvd = parsearHora(contenedor.getAttribute('data-omprod-corte-sabado-mvd'));
          var reglasMvd = {
            0: null,
            1: corteSemanaMvd,
            2: corteSemanaMvd,
            3: corteSemanaMvd,
            4: corteSemanaMvd,
            5: corteSemanaMvd,
            6: corteSabadoMvd
          };

          var corteSemanaInt = parsearHora(contenedor.getAttribute('data-omprod-corte-semana-int'));
          var reglasInt = {
            0: null,
            1: corteSemanaInt,
            2: corteSemanaInt,
            3: corteSemanaInt,
            4: corteSemanaInt,
            5: corteSemanaInt,
            6: null
          };

          var elementoMvd = contenedor.querySelector('[data-omprod-entrega-mvd]');
          if (elementoMvd) {
            var plantillaMvd = contenedor.getAttribute('data-omprod-plantilla-mvd') || '';
            var offsetMvd = calcularProximoDia(diaActual, minutosDelDia, reglasMvd);
            if (offsetMvd !== null) {
              var nombreMvd = nombreParaOffset(offsetMvd, diaActual, textoHoy, textoManana);
              elementoMvd.textContent = plantillaMvd.replace('[dia]', nombreMvd);
            }
          }

          var elementoInt = contenedor.querySelector('[data-omprod-entrega-int]');
          if (elementoInt) {
            var plantillaInt = contenedor.getAttribute('data-omprod-plantilla-int') || '';
            var offsetInt = calcularProximoDia(diaActual, minutosDelDia, reglasInt);
            if (offsetInt !== null) {
              var nombreInt = nombreParaOffset(offsetInt, diaActual, textoHoy, textoManana);
              elementoInt.textContent = plantillaInt.replace('[dia]', nombreInt);
            }
          }
        });
      }

      function formatearContador(segundosRestantes) {
        if (segundosRestantes < 0) { segundosRestantes = 0; }
        var horas = Math.floor(segundosRestantes / 3600);
        var minutos = Math.floor((segundosRestantes % 3600) / 60);
        var segundos = segundosRestantes % 60;
        function dosDigitos(numero) { return numero < 10 ? '0' + numero : '' + numero; }
        if (horas > 0) {
          return horas + ':' + dosDigitos(minutos) + ':' + dosDigitos(segundos);
        }
        return minutos + ':' + dosDigitos(segundos);
      }

      function actualizarContadoresEntrega() {
        var contenedores = document.querySelectorAll('[data-omcont-texto-mvd-activo], [data-omcont-texto-int-activo]');
        if (!contenedores.length) { return; }

        var partes = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Montevideo',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).formatToParts(new Date());

        var diasSemana = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        var diaActual = 0;
        var horas = 0;
        var minutos = 0;
        var segundos = 0;

        partes.forEach(function (parte) {
          if (parte.type === 'weekday') { diaActual = diasSemana[parte.value]; }
          if (parte.type === 'hour') { horas = parseInt(parte.value, 10); }
          if (parte.type === 'minute') { minutos = parseInt(parte.value, 10); }
          if (parte.type === 'second') { segundos = parseInt(parte.value, 10); }
        });

        if (horas === 24) { horas = 0; }
        var segundosDelDia = (horas * 3600) + (minutos * 60) + segundos;
        var minutosDelDia = Math.floor(segundosDelDia / 60);

        contenedores.forEach(function (contenedor) {
          var textoHoy = contenedor.getAttribute('data-omcont-texto-hoy') || 'hoy';
          var textoManana = contenedor.getAttribute('data-omcont-texto-manana') || 'mañana';

          var elementoMvd = contenedor.querySelector('[data-omcont-mvd]');
          if (elementoMvd) {
            var corteSemanaMvd = parsearHora(contenedor.getAttribute('data-omcont-corte-semana-mvd'));
            var corteSabadoMvd = parsearHora(contenedor.getAttribute('data-omcont-corte-sabado-mvd'));
            var corteMinutosHoyMvd = null;
            if (diaActual >= 1 && diaActual <= 5) {
              corteMinutosHoyMvd = corteSemanaMvd;
            } else if (diaActual === 6) {
              corteMinutosHoyMvd = corteSabadoMvd;
            }
            var corteSegundosHoyMvd = corteMinutosHoyMvd === null ? null : corteMinutosHoyMvd * 60;

            if (corteSegundosHoyMvd !== null && segundosDelDia < corteSegundosHoyMvd) {
              var restanteMvd = corteSegundosHoyMvd - segundosDelDia;
              var plantillaActivaMvd = contenedor.getAttribute('data-omcont-texto-mvd-activo') || '';
              elementoMvd.textContent = plantillaActivaMvd.replace('[contador]', formatearContador(restanteMvd));
              elementoMvd.classList.add('omcont-linea--activo');
            } else {
              var reglasMvd = {
                0: null,
                1: corteSemanaMvd,
                2: corteSemanaMvd,
                3: corteSemanaMvd,
                4: corteSemanaMvd,
                5: corteSemanaMvd,
                6: corteSabadoMvd
              };
              var offsetMvd = calcularProximoDia(diaActual, minutosDelDia, reglasMvd);
              var plantillaVencidaMvd = contenedor.getAttribute('data-omcont-texto-mvd-vencido') || '';
              if (offsetMvd !== null) {
                var nombreMvdVenc = nombreParaOffset(offsetMvd, diaActual, textoHoy, textoManana);
                elementoMvd.textContent = plantillaVencidaMvd.replace('[dia]', nombreMvdVenc);
              }
              elementoMvd.classList.remove('omcont-linea--activo');
            }
          }

          var elementoInt = contenedor.querySelector('[data-omcont-int]');
          if (elementoInt) {
            var corteSemanaInt = parsearHora(contenedor.getAttribute('data-omcont-corte-semana-int'));
            var corteMinutosHoyInt = (diaActual >= 1 && diaActual <= 5) ? corteSemanaInt : null;
            var corteSegundosHoyInt = corteMinutosHoyInt === null ? null : corteMinutosHoyInt * 60;

            if (corteSegundosHoyInt !== null && segundosDelDia < corteSegundosHoyInt) {
              var restanteInt = corteSegundosHoyInt - segundosDelDia;
              var plantillaActivaInt = contenedor.getAttribute('data-omcont-texto-int-activo') || '';
              elementoInt.textContent = plantillaActivaInt.replace('[contador]', formatearContador(restanteInt));
              elementoInt.classList.add('omcont-linea--activo');
            } else {
              var reglasInt = {
                0: null,
                1: corteSemanaInt,
                2: corteSemanaInt,
                3: corteSemanaInt,
                4: corteSemanaInt,
                5: corteSemanaInt,
                6: null
              };
              var offsetInt = calcularProximoDia(diaActual, minutosDelDia, reglasInt);
              var plantillaVencidaInt = contenedor.getAttribute('data-omcont-texto-int-vencido') || '';
              if (offsetInt !== null) {
                var nombreIntVenc = nombreParaOffset(offsetInt, diaActual, textoHoy, textoManana);
                elementoInt.textContent = plantillaVencidaInt.replace('[dia]', nombreIntVenc);
              }
              elementoInt.classList.remove('omcont-linea--activo');
            }
          }
        });
      }

      function iniciarOmprod() {
        actualizarEntregaAutomatica();
        actualizarContadoresEntrega();
        setInterval(actualizarContadoresEntrega, 1000);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciarOmprod);
      } else {
        iniciarOmprod();
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  if (window.omrpRelacionadosListo) {
    return;
  }
  window.omrpRelacionadosListo = true;

  function manejarEnvioFormulario(formulario) {
    var boton = formulario.querySelector('[data-omrp-agregar]');
    if (!boton || boton.disabled || boton.getAttribute('data-cargando') === 'true') {
      return;
    }

    var campoVariante = formulario.querySelector('input[name="id"]');
    var variantId = campoVariante ? campoVariante.value : '';
    var errorEl = formulario.querySelector('[data-omrp-error]');

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    if (!variantId) {
      if (errorEl) {
        errorEl.textContent = 'Este producto no tiene una variante disponible para agregar.';
        errorEl.hidden = false;
      }
      return;
    }

    var textoSpan = boton.querySelector('.omrp-boton-texto');
    var textoOriginal = textoSpan ? textoSpan.textContent : '';
    var textoCargando = boton.getAttribute('data-texto-cargando') || 'Agregando...';
    boton.setAttribute('data-cargando', 'true');
    if (textoSpan) {
      textoSpan.textContent = textoCargando;
    }

    var cuerpo = { id: variantId, quantity: 1 };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (respuesta) {
        return respuesta.json().then(function (datos) {
          if (!respuesta.ok) {
            var mensaje = (datos && (datos.description || datos.message)) || 'No se pudo agregar el producto.';
            throw new Error(mensaje);
          }
          return datos;
        });
      })
      .then(function () {
        if (textoSpan) {
          textoSpan.textContent = textoOriginal;
        }
        boton.removeAttribute('data-cargando');
      })
      .catch(function (error) {
        if (textoSpan) {
          textoSpan.textContent = textoOriginal;
        }
        boton.removeAttribute('data-cargando');
        if (errorEl) {
          errorEl.textContent = error && error.message ? error.message : 'No se pudo agregar el producto.';
          errorEl.hidden = false;
        }
        if (window.console && window.console.error) {
          window.console.error('omrp: error al agregar al carrito', error);
        }
      });
  }

  document.addEventListener('submit', function (evento) {
    var formulario = evento.target.closest('[data-omrp-formulario]');
    if (!formulario) {
      return;
    }
    if (evento.defaultPrevented) {
      return;
    }
    evento.preventDefault();
    manejarEnvioFormulario(formulario);
  });

  function parsearHora(valor, minutosPorDefecto) {
    if (!valor) {
      return minutosPorDefecto;
    }
    var partes = valor.split(':');
    var horas = parseInt(partes[0], 10);
    var minutos = partes.length > 1 ? parseInt(partes[1], 10) : 0;
    if (isNaN(horas)) {
      return minutosPorDefecto;
    }
    if (isNaN(minutos)) {
      minutos = 0;
    }
    return (horas * 60) + minutos;
  }

  function calcularProximoDia(diaActual, minutosDelDia, reglas) {
    var corteHoy = reglas[diaActual];
    if (typeof corteHoy === 'number' && minutosDelDia < corteHoy) {
      return 0;
    }
    for (var i = 1; i <= 7; i++) {
      var d = (diaActual + i) % 7;
      if (typeof reglas[d] === 'number') {
        return i;
      }
    }
    return null;
  }

  function nombreParaOffset(offset, diaActual, textoHoy, textoManana, nombresDias) {
    if (offset === 0) {
      return textoHoy;
    }
    if (offset === 1) {
      return textoManana;
    }
    var d = (diaActual + offset) % 7;
    return 'el ' + nombresDias[d];
  }

  function actualizarEntregaAutomatica() {
    var contenedores = document.querySelectorAll('[data-omrp-corte-semana-mvd]');
    if (!contenedores.length) {
      return;
    }

    var nombresDias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var diasAbrev = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var partesFecha;

    try {
      partesFecha = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Montevideo',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (error) {
      return;
    }

    var datosFecha = {};
    partesFecha.forEach(function (parte) {
      datosFecha[parte.type] = parte.value;
    });

    var diaActual = diasAbrev.indexOf(datosFecha.weekday);
    var horaActual = parseInt(datosFecha.hour, 10);
    if (horaActual === 24) {
      horaActual = 0;
    }
    var minutoActual = parseInt(datosFecha.minute, 10);

    if (diaActual === -1 || isNaN(horaActual) || isNaN(minutoActual)) {
      return;
    }

    var minutosDelDia = (horaActual * 60) + minutoActual;

    contenedores.forEach(function (contenedor) {
      var corteSemanaMvd = parsearHora(contenedor.getAttribute('data-omrp-corte-semana-mvd'), 14 * 60);
      var corteSabadoMvd = parsearHora(contenedor.getAttribute('data-omrp-corte-sabado-mvd'), 10 * 60);
      var corteSemanaInt = parsearHora(contenedor.getAttribute('data-omrp-corte-semana-int'), (18 * 60) + 30);
      var plantillaMvd = contenedor.getAttribute('data-omrp-plantilla-mvd') || '';
      var plantillaInt = contenedor.getAttribute('data-omrp-plantilla-int') || '';
      var textoHoy = contenedor.getAttribute('data-omrp-texto-hoy') || 'hoy';
      var textoManana = contenedor.getAttribute('data-omrp-texto-manana') || 'mañana';

      var reglasMvd = { 0: null, 1: corteSemanaMvd, 2: corteSemanaMvd, 3: corteSemanaMvd, 4: corteSemanaMvd, 5: corteSemanaMvd, 6: corteSabadoMvd };
      var reglasInt = { 0: null, 1: corteSemanaInt, 2: corteSemanaInt, 3: corteSemanaInt, 4: corteSemanaInt, 5: corteSemanaInt, 6: null };

      var offsetMvd = calcularProximoDia(diaActual, minutosDelDia, reglasMvd);
      var offsetInt = calcularProximoDia(diaActual, minutosDelDia, reglasInt);

      if (offsetMvd !== null && plantillaMvd) {
        var textoFinalMvd = plantillaMvd.replace('[dia]', nombreParaOffset(offsetMvd, diaActual, textoHoy, textoManana, nombresDias));
        contenedor.querySelectorAll('[data-omrp-entrega-mvd]').forEach(function (el) {
          el.textContent = textoFinalMvd;
        });
      }

      if (offsetInt !== null && plantillaInt) {
        var textoFinalInt = plantillaInt.replace('[dia]', nombreParaOffset(offsetInt, diaActual, textoHoy, textoManana, nombresDias));
        contenedor.querySelectorAll('[data-omrp-entrega-int]').forEach(function (el) {
          el.textContent = textoFinalInt;
        });
      }
    });
  }

  function observarRecomendaciones() {
    var elementos = document.querySelectorAll('product-recommendations[data-omrp-corte-semana-mvd]');
    if (!elementos.length) {
      return;
    }

    var observadores = [];

    function desconectarTodos() {
      observadores.forEach(function (item) {
        item.observador.disconnect();
      });
    }

    function reobservarTodos() {
      observadores.forEach(function (item) {
        item.observador.observe(item.elemento, { childList: true, subtree: true });
      });
    }

    elementos.forEach(function (elemento) {
      var observador = new MutationObserver(function () {
        desconectarTodos();
        actualizarEntregaAutomatica();
        reobservarTodos();
      });
      observadores.push({ observador: observador, elemento: elemento });
    });

    reobservarTodos();
  }

  actualizarEntregaAutomatica();
  observarRecomendaciones();
})();

  } catch(e) { console.error(e); }
})();
})();
